export type FormFieldErrorVariant = 'rail' | 'border';

type VariantClassNames = {
    container: string;
    control?: string;
};

export const defaultFormFieldErrorVariant: FormFieldErrorVariant = 'rail';

export const formFieldErrorVariantClasses: Record<FormFieldErrorVariant, VariantClassNames> = {
    rail: {
        container: 'form-field--error-rail',
    },
    border: {
        container: 'form-field--error-border',
        control: 'form-control--error-border',
    },
};

export const resolveFormFieldErrorVariant = (
    variant?: FormFieldErrorVariant,
): FormFieldErrorVariant => variant ?? defaultFormFieldErrorVariant;
